<div mat-dialog-content>
  <h2>êtes-vous sûr de vouloir supprimer cet élément</h2>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="decline()" cdkFocusInitial>Non</button>
  <button mat-button color="warn" (click)="confirm()">Oui</button>
</div>
